export enum IconFillColor {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Special = 'special',
  Highlight = 'highlight',
  Neon = 'neon',
  Confirmed = 'confirmed',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
  ValueProp = 'value-prop',
  Disabled = 'disabled',
  Pay = 'pay',
  Light = 'light',
  PrimeBranding = 'prime-branding',
}

export enum Icon {
  // Icon Product Outline
  Flights = 'flights',
  Hotels = 'hotels',
  Autos = 'autos',
  Packages = 'packages',
  Buses = 'buses',
  Activities = 'activities',
  ByHours = 'by-hours',
  // Icon Chevron Outline
  ChevronRight = 'chevron-right',
  ChevronUp = 'chevron-up',
  ChevronDown = 'chevron-down',
  ChevronLeft = 'chevron-left',
  // Icon Chevron Filled
  ChevronFilledDown = 'chevron-filled-down',
  ChevronFilledUp = 'chevron-filled-up',
  // Icon Arrows Outline
  ArrowUp = 'arrow-up',
  ArrowRight = 'arrow-right',
  ArrowDown = 'arrow-down',
  ArrowLeft = 'arrow-left',
  ArrowDerivated = 'arrow-derivated',
  // Icon Common Outline
  Substract = 'substract',
  MinusCircleOutline = 'minus-circle-outline',
  FlexibleDates = 'flexible-dates',
  ImageNotAvailable = 'image-not-available',
  Backpack = 'backpack',
  HandLuggage = 'hand-luggage',
  Luggage = 'luggage',
  WithoutLuggage = 'without-luggage',
  Seats = 'seats',
  Seat = 'seat',
  SeatPitch = 'seat-pitch',
  SeatWidth = 'seat-width',
  SeatInclination = 'seat-inclination',
  Roundtrip = 'roundtrip',
  PlaneAlt = 'plane-alt',
  Departure = 'departure',
  Flight1 = 'flight1',
  Flight2 = 'flight2',
  Search = 'search',
  StartPoint = 'start-point',
  Location = 'location',
  Calendar = 'calendar',
  Notification = 'notification',
  NotificationCrossOut = 'notification-cross-out',
  Check = 'check',
  Close = 'close',
  CancelCircleOutline = 'cancel-circle-outline',
  Add = 'add',
  AddCircleOutline = 'add-circle-outline',
  CreditCard = 'credit-card',
  Whatsapp = 'whatsapp',
  EditOutline = 'edit-outline',
  Bed = 'bed',
  PersonOutline = 'person-outline',
  Group = 'group',
  Support = 'support',
  WorkOutline = 'work-outline',
  Rock = 'rock',
  InFlightEntertainment = 'in-flight-entertainment',
  Power = 'power',
  Wifi = 'wifi',
  Gym = 'gym',
  Pool = 'pool',
  Parking = 'parking',
  Low = 'low',
  Medium = 'medium',
  High = 'high',
  NoMoney = 'no-money',
  MoneyIcon = 'money-icon',
  IntermediatePrice = 'intermediate-price',
  Expensive = 'expensive',
  Morning = 'morning',
  Afternoon = 'afternoon',
  MorningMoon = 'morning-moon',
  Evening = 'evening',
  EconomicHotel = 'economic-hotel',
  BigHotel = 'big-hotel',
  PremiumHotel = 'premium-hotel',
  StarOutline = 'star-outline',
  SentimentPositive = 'sentiment-positive',
  SentimentNeutral = 'sentiment-neutral',
  SentimentNegative = 'sentiment-negative',
  Trash = 'trash',
  Warning = 'warning',
  Info = 'info',
  Monetization = 'monetization',
  Coupon = 'coupon',
  Clock = 'clock',
  Promotion = 'promotion',
  AutoBrand = 'auto-brand',
  PriceRefresh = 'price-refresh',
  Door = 'door',
  MultipleFlights = 'multiple-flights',
  Passport = 'passport',
  Expand = 'expand',
  AnchorLink = 'anchor-link',
  List = 'list',
  RoomSize = 'room-size',
  Dialog = 'dialog',
  LockOutline = 'lock-outline',
  TrophyOutline = 'trophy-outline',
  Counter = 'counter',
  TopUp = 'top-up',
  Refund = 'refund',
  AccountState = 'account-state',
  NoCash = 'no-cash',
  Cashback = 'cashback',
  Without = 'without',
  SwapVert = 'swap-vert',
  Divide = 'divide',
  Stop = 'stop',
  OrderAgain = 'order-again',
  DepartureDuration = 'departure-duration',
  Security = 'security',
  CheckProtection = 'check-protection',
  Scale = 'scale',
  Twoscales = 'twoscales',
  MoreThanTwoScales = 'more-than-two-scales',
  Profile = 'profile',
  Children = 'children',
  ProfileCircle = 'profile-circle',
  CopyToClipboard = 'copy-to-clipboard',
  PhoneIphone = 'phone-iphone',
  AddLocation = 'add-location',
  Share = 'share',
  Filter = 'filter',
  General = 'general',
  Cooperative = 'cooperative',
  Ticket = 'ticket',
  Email = 'email',
  Phone = 'phone',
  Points = 'points',
  Restaurant = 'restaurant',
  HotOutline = 'hot-outline',
  Process = 'process',
  MoreVert = 'more-vert',
  Gallery = 'gallery',
  HeartOutline = 'heart-outline',
  Family = 'family',
  Pet = 'pet',
  ShoppingBag = 'shopping-bag',
  Accessibility = 'accessibility',
  Market = 'market',
  VIP = 'vip',
  Gift = 'gift',
  Business = 'business',
  Key = 'key',
  CarDoor = 'car-door',
  CarChange = 'car-change',
  Freeze = 'freeze',
  Home = 'home',
  // Icon Common Filled
  BulletA = 'bullet-a',
  BulletB = 'bullet-b',
  BulletC = 'bullet-c',
  Cancel = 'cancel',
  Star = 'star',
  Hot = 'hot',
  WarningFilled = 'warning-filled',
  Heart = 'heart',
  Lock = 'lock',
  Stars = 'stars',
  DirectionBus = 'direction-bus',
  Edit = 'edit',
  InfoFilled = 'info-filled',
  AddCircle = 'add-circle',
  Trophy = 'trophy',
  // Icon Branded Filled
  MarriottBonvoy = 'marriott-bonvoy',
  MarriottBonvoyFlat = 'marriott-bonvoy-flat',
  MustacheFlat = 'mustache-flat',
  Civitatis = 'civitatis',
  Apple = 'apple',
  PlayStore = 'play-store',
  AppGallery = 'app-gallery',
  Facebook = 'facebook',
  X = 'x',
  Instagram = 'instagram',
  CivitatisFlat = 'civitatis-flat',
  RappiCardProVert = 'rappi-card-pro-vert',
  RappiProHorz = 'rappi-pro-horz',
  Prime = 'prime',
}

export interface IconGraphic {
  d?: string;
  rect?: IconRect;
  circle?: IconCircle;
  ellipse?: IconEllipse;
  mask?: IconMask,
  maskId?: string;
  fill?: string;
  stroke?: IconStroke;
  gradient?: IconGradient;
  points?: string;
}

interface IconRect {
  x?: string;
  y?: string;
  width?: string;
  height?: string;
  rx?: string;
  ry?: string;
}

interface IconCircle {
  cx?: string;
  cy?: string;
  r?: string;
}

interface IconEllipse {
  cx?: string;
  cy?: string;
  rx?: string;
  ry?: string
}

interface IconMask {
  id: string;
  fill: string;
  d: string;
}

interface IconStroke {
  fillIsDisabled: boolean;
  strokeDefault: boolean;
  strokeColor: boolean;
  width?: string;
}

interface IconGradient {
  d?: string;
  fill?: string;
  id?: string;
  x1?: string;
  y1?: string;
  x2?: string;
  y2?: string;
  gradientUnits?: string;
  stops: IconStopGradient[];
}

interface IconStopGradient {
  offset?: string;
  stopColor?: string;
}
